import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { TimePicker } from '@syncfusion/ej2-calendars';



export const /** @type {?} */ inputs: string[] = ['allowEdit','cssClass','enablePersistence','enableRtl','enabled','floatLabelType','format','htmlAttributes','keyConfigs','locale','max','min','openOnFocus','placeholder','readonly','scrollTo','showClearButton','step','strictMode','value','width','zIndex'];
export const /** @type {?} */ outputs: string[] = ['blur','change','cleared','close','created','destroyed','focus','itemRender','open','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * Represents the Essential JS 2 Angular TimePicker Component.
 * ```html
 * <ejs-timepicker [value]='dateTime'></ejs-timepicker>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class TimePickerComponent extends TimePicker implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public valueChange: any;
private skipFromEvent:boolean = true;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-timepicker',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimePickerComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function TimePickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
TimePickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TimePickerComponent.ctorParameters;
/** @type {?} */
TimePickerComponent.prototype.formCompContext;
/** @type {?} */
TimePickerComponent.prototype.formContext;
/** @type {?} */
TimePickerComponent.prototype.tagObjects;
/** @type {?} */
TimePickerComponent.prototype.valueChange;
/** @type {?} */
TimePickerComponent.prototype.skipFromEvent;
/** @type {?} */
TimePickerComponent.prototype.registerEvents;
/** @type {?} */
TimePickerComponent.prototype.addTwoWay;
/** @type {?} */
TimePickerComponent.prototype.ngEle;
/** @type {?} */
TimePickerComponent.prototype.srenderer;
/** @type {?} */
TimePickerComponent.prototype.viewContainerRef;
/** @type {?} */
TimePickerComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
